import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from 'react-icons/fa';
import * as C from './styles';

export const Footer = () => {
  return (
    <C.Footer>
      <C.FooterContainer>
        <C.FooterContent>
          <C.FooterSection>
            <C.FooterTitle>Menu</C.FooterTitle>
            <C.FooterLinks>
              <C.FooterLink>
                <Link to="/politica-privacidade">Política de Privacidade</Link>
              </C.FooterLink>
              <C.FooterLink>
                <a href="https://getap.agr.br/quem-somos/">Quem Somos</a>
              </C.FooterLink>
              <C.FooterLink>
                <a href="https://getap.agr.br/noticias/">Notícias</a>
              </C.FooterLink>
              <C.FooterLink>
                <a href="https://getap.agr.br/eventos/">Eventos</a>
              </C.FooterLink>
              <C.FooterLink>
                <a href="https://getap.agr.br/contato/">Contato</a>
              </C.FooterLink>
            </C.FooterLinks>
          </C.FooterSection>

          <C.FooterSection>
            <C.FooterTitle>Contato</C.FooterTitle>
            <C.ContactInfo>
              <C.ContactItem>
                Av. Nicomedes Alves dos Santos, 1205 - Sala 208 - Altamira, Uberlândia - MG, 38408-448
              </C.ContactItem>
              <C.ContactItem>
                <a href="tel:+553432291313">+55 (34) 3229-1313</a>
              </C.ContactItem>
            </C.ContactInfo>
          </C.FooterSection>

          <C.FooterSection>
            <C.SocialLinks>
              <C.SocialLink
                href="https://www.facebook.com/getap.agr"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </C.SocialLink>
              <C.SocialLink
                href="https://www.instagram.com/getap.agr"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram />
              </C.SocialLink>
              <C.SocialLink
                href="https://www.youtube.com/@getap"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Youtube"
              >
                <FaYoutube />
              </C.SocialLink>
              <C.SocialLink
                href="https://www.linkedin.com/company/getap"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FaLinkedinIn />
              </C.SocialLink>
            </C.SocialLinks>
          </C.FooterSection>
        </C.FooterContent>

        <C.FooterBottom>
          <C.Copyright>
            © {new Date().getFullYear()} – Todos os Direitos Reservados – Desenvolvido por{' '}
            <a href="https://yazon.com.br" target="_blank" rel="noopener noreferrer">
              Yazon
            </a>
          </C.Copyright>
        </C.FooterBottom>
      </C.FooterContainer>
    </C.Footer>
  );
};



